import { styled } from '@mui/material';

export const ProductLibraryBackground = styled('div')`
  background-color: ${({ theme }) => theme.palette.background.default};
  flex-grow: 1;
  overflow: auto;
  min-width: 200px;
  ${({ theme }) => theme.mixins.hideScrollbar}
`;
